import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  fourVideo: [],
  selectedPipeline: {},
  listOfSelectedPipeline:[],
  selectedVideoHome: null,
};

const videoSlice = createSlice({
  name: "videoReducer",
  initialState,
  reducers: {
    setFourVideo: (state, action) => {
      state.fourVideo = action.payload;
    },
    setSelectedPipeline: (state, action) => {
      state.selectedPipeline = action.payload;
    },
    setListOfSelectedPipeline: (state, action) => {
      state.listOfSelectedPipeline = [...state.listOfSelectedPipeline,action.payload];
    },
    setListOfSelectedPipelineNew: (state, action) => {
      state.listOfSelectedPipeline = action.payload
    },
    setSelectedVideoHome: (state, action) => {
      state.selectedVideoHome = action.payload;
    },
  },
});

export const { setFourVideo, setSelectedPipeline,setSelectedVideoHome,setListOfSelectedPipeline,setListOfSelectedPipelineNew } = videoSlice.actions;
export default videoSlice.reducer;
